<template>
	<el-collapse v-model="activeNames" class="custom-collapse isStyleLimit" :class="$style.box">
		<el-form class="el-form-item--white-bg" :validate-on-rule-change="true" :rules="formRules" label-position="top">
			<el-collapse-item style="border:0">
				<div slot="title" class="el-collapse-title d-flex align-items-center">
					<span class="d-lg-inline d-none" style="margin-left:35px">星期
						<span>週末折扣9折</span></span>
					<span class="d-lg-inline d-none" style="margin-left:35px"> 2022/03/12 ~
						2022/03/15</span>
					<div class="ml-auto">
						<el-switch active-text="開放" inactive-text="關閉" :active-value="1" :inactive-value="0"
							@click.stop.native></el-switch>
					</div>
				</div>

				<el-row :gutter="10">
					<el-col :span="24">
						<el-form-item :label="titleComputed">
							<el-input v-model="timeClass">
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="時段類別" prop="name">
							<el-select v-model="timeClass">
								<el-option label="只匯出訂單資訊" value="byOrder"></el-option>
								<el-option label="匯出訂單資訊與參與人資訊" value="byPerson"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="日期" prop="name">
							<el-date-picker v-model="filterDateRange" type="daterange" align="left" unlink-panels range-separator="-"
								start-placeholder="起始日期" end-placeholder="結束日期" :picker-options="pickerOptions"
								:clearable="false"></el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="10" v-if="openType === 'change'">
					<el-col :span="12">
						<el-form-item label="價格調整">
							<el-radio-group :class="$style.changePriceElRadioGroup">
								<el-radio v-for="store in changeProducts" :label="store.id">{{ store.name }}</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="金額" prop="name">
							<div style="display:flex">
								<el-input />
								<span style="margin-left: 10px;">%</span>
							</div>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="10" v-if="openType === 'second'">
					<el-col :span="6">
						<el-form-item label="同時段安親第二隻折扣">
							<el-radio-group :class="$style.changePriceElRadioGroup">
								<el-radio v-for="store in secondProducts" :label="store.id">{{ store.name }}</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="18">
						<el-form-item label=" " prop="name" class="is-empty-label">
							<div style="display:flex">
								<el-input placeholder="金額" />
								<span style="margin-left: 10px;">%</span>
							</div>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="20">
					<el-col :lg="24" :span="24">
						<div :class="$style.treeTitle">
							<h6 class="fs-base fw-regular text-text h6Margin">適用服務</h6>
							<el-checkbox>全部分店服務適用</el-checkbox>
						</div>
						<el-row :gutter="0">
							<el-col :sm="12" :span="24">
								<div>
									<Tree type="product" buttonName="新增適用分店" empty-name="請選擇適用分店"></Tree>
								</div>
							</el-col>
							<el-col :sm="12" :span="24">
								<div>
									<Tree type="service" button-name="新增適用服務項目" empty-name="請選擇適用服務項目"></Tree>
								</div>
							</el-col>
						</el-row>
					</el-col>
				</el-row>

				<el-row :gutter="20">
					<el-col :lg="24" :span="24">
						<div :class="$style.treeTitle">
							<h6 class="fs-base fw-regular text-text h6Margin">適用加購服務</h6>
							<el-checkbox>全部分店服務適用</el-checkbox>
						</div>
						<el-row :gutter="0">
							<el-col :sm="12" :span="24">
								<div>
									<Tree type="product" buttonName="新增適用分店" empty-name="請選擇適用分店"></Tree>
								</div>
							</el-col>
							<el-col :sm="12" :span="24">
								<div>
									<Tree type="service" button-name="新增適用服務項目" empty-name="請選擇適用服務項目"></Tree>
								</div>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
			</el-collapse-item>
		</el-form>
	</el-collapse>
</template>

<script>
import lazyLoadComponent from '@router/lazyload-component'

export default {
	name: 'Hello',
	data() {
		return {
			activeNames: [],
			filterDateRange: [], // 起始日期/結束日期
			pickerOptions: {
				shortcuts: [
					{
						text: '最近一週',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
							picker.$emit('pick', [start, end])
						},
					},
					{
						text: '最近一個月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
							picker.$emit('pick', [start, end])
						},
					},
					{
						text: '最近三個月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
							picker.$emit('pick', [start, end])
						},
					},
					{
						text: '最近一年',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
							picker.$emit('pick', [start, end])
						},
					},
				],
			},
			changeProducts: [
				{ id: 1, name: '減價' },
				{ id: 2, name: '折扣' },
				{ id: 3, name: '加價' },
				{ id: 4, name: '增額' },
			],
			secondProducts: [
				{ id: 1, name: '減價' },
				{ id: 2, name: '折扣' }
			],
			timeClass: "", // 時段類別
		};
	},
	props: {
		openType: {
			type: String,
			required: true,
		}
	},
	computed: {
		formRules() {
			return {
				name: [
					{
						required: true,
						message: '請輸入限制名稱',
						trigger: 'blur',
					},
				],
				startDate: [
					{
						required: true,
						message: '請輸入日期',
						trigger: 'blur',
					},
				],
				range: [
					{
						required: true,
						validator: (rule, value, callback) => {
							// console.log(value)
							if (value.length === 0) {
								return callback(new Error('請選擇日期'))
							} else {
								callback()
							}
						},
						trigger: 'change',
					},
				],
			}
		},
		titleComputed() {
			// console.log(this.openType)
			if (this.openType === 'change') {
				return '折扣時段標題'
			}
			if (this.openType === 'second') {
				return '標題'
			}
		}
	},
	created() { },
	mounted() { },
	methods: {},
	components: {
		Tree: () => lazyLoadComponent(import('./Tree')),
	},
};
</script>

<style lang="scss" module>
.treeTitle {
	display: flex;
	justify-content: start;
	align-items: center;

	:global {
		.h6Margin {
			margin-right: 10px;
		}
	}
}
.changePriceElRadioGroup {
	display: flex;
	justify-content: space-around;
	align-items: center;
	height: 44px;
}
.box {
	border: $color-border-base 1px solid;
	padding: 1px;
	border-radius: 6px;
	margin-bottom: 10px;

	:global {
		.el-collapse-item__header {
			border: 0;
		}

		.el-collapse-item__wrap {
			border: 0;
		}

		.el-form-item {
			margin-bottom: 15px;
		}

		.el-input__inner {
			border-color: $color-border-base;

			&:focus {
				border-color: $color-primary;
			}
		}

		.inline-section {
			display: flex;
			// margin-bottom: 15px;
		}

		.el-button.is-no-border {
			border: 0;
		}
	}
}
</style>
